import React from 'react';
import { FaArrowLeft, FaLemon, FaGem, FaBell, FaStar, FaDice, FaAppleAlt } from 'react-icons/fa';
import { GiCherry } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import DelayRender from './DelayRender';
import './SlotMachine.css';
import { useSlotMachine } from './SlotMachineFunctions';

const SlotMachine = () => {
  const navigate = useNavigate();
  const {
    user,
    reels,
    spinning,
    betAmount,
    message,
    spin,
    handleBet,
    clearBet,
    betDenominations,
  } = useSlotMachine();

  const handleVariants = {
    pull: { rotate: 30, originY: 1, transition: { type: "spring", stiffness: 300, damping: 15 } },
    release: { rotate: 0, originY: 1, transition: { type: "spring", stiffness: 300, damping: 15 } }
  };

  const reelVariants = {
    spinning: {
      y: [0, -100, 0],
      transition: {
        y: {
          repeat: Infinity,
          repeatType: "loop",
          duration: 0.5,
          ease: "linear",
        }
      }
    },
    stopped: { y: 0 }
  };

  const handlePull = () => {
    if (!spinning) {
      spin();
    }
  };

  const renderSymbol = (symbol) => {
    switch (symbol) {
      case 'cherry': return <GiCherry />;
      case 'lemon': return <FaLemon />;
      case 'apple': return <FaAppleAlt />;
      case 'gem': return <FaGem />;
      case 'bell': return <FaBell />;
      case 'star': return <FaStar />;
      case 'seven': return <FaDice />;
      default: return null;
    }
  };

  return (
    <div className="page">
      <div className="page-container">
        <div className="casino-header">
          <div className="back-button-container">
            <FaArrowLeft className="back-button" onClick={() => navigate(-1)} />
          </div>
          <h3 className="game-header">Classic Slots</h3>
          <p className="slot-balance">Balance: 💴 {user?.money?.toFixed(2) ?? '0.00'}</p>
        </div>
        <div className="slot-machine-game">
          <div className="slot-machine">
            <div className="slot-window">
              {reels && reels.map((reel, reelIndex) => (
                <motion.div 
                  key={reelIndex} 
                  className="reel"
                  variants={reelVariants}
                  animate={spinning ? "spinning" : "stopped"}
                >
                  {reel.map((symbol, symbolIndex) => (
                    <div key={symbolIndex} className="symbol" data-symbol={symbol}>
                      {renderSymbol(symbol)}
                    </div>
                  ))}
                </motion.div>
              ))}
              <div className="middle-row-highlight"></div>
            </div>
            <motion.div 
              className="slot-handle"
              variants={handleVariants}
              animate={spinning ? "pull" : "release"}
              onClick={handlePull}
            >
              <div className="handle-top"></div>
              <div className="handle-body"></div>
            </motion.div>
          </div>
          <div className="betting-controls">
            <div className="bet-buttons">
              {betDenominations.map((amount, index) => (
                <div
                  key={index}
                  className={`chip chip-${amount}`}
                  onClick={() => handleBet(amount)}
                >
                  <span>{amount}</span>
                </div>
              ))}
            </div>
            <div>
              <button className="spin-button" onClick={spin} disabled={spinning}>
                {spinning ? 'Spinning...' : `Spin 💴${betAmount}`}
              </button>
              <button className="clear-bet-button" onClick={clearBet}>Clear Bet</button>
            </div>
          </div>
          <div className="message">
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DelayRender(SlotMachine, 200);
